export default "__VITE_ASSET__06d6afba__"